export class MotionOnScroll {
    private readonly trigger: HTMLElement;
    private isAnimated: Boolean;

    constructor(trigger: HTMLElement) {
        this.trigger = trigger;
        this.isAnimated = false;
        this.init();
    }

    public hasAttribute(): Boolean {
        return !!this.trigger.getAttribute(`data-animate`);
    }

    private animate(): void {
        this.trigger.classList.add(`is-animated`);
        this.isAnimated = true;
    }

    protected onScroll(): void {
        if (!this.isAnimated) {
            let position = this.trigger.getBoundingClientRect().top;
            let win = window.innerHeight;

            if (position < win) this.animate();
            return;
        }
        window.removeEventListener(`scroll`, this.onScroll.bind(this));
    }

    init(): void {
        if (this.trigger && this.hasAttribute()) {
            this.onScroll();
            window.addEventListener(`scroll`, this.onScroll.bind(this));
        }
    }
}